import React from 'react';
import Post from "../../../components/pages/grid/Post/Post";

const PostGridPage = () => {
    return <Post />
};

export default PostGridPage;